import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IoniconsFilled, IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-header',
  templateUrl: 'widget-header.component.html',
  styleUrls: ['widget-header.component.scss']
})
export class WidgetHeaderComponent {

  @Input() label: string;
  @Input() help: string;
  @Input() warning: string;
  @Input() comment: string;
  @Input() unsavedComment: string;
  @Input() loading: boolean;

  @Input() showEditButton: boolean;
  @Input() showSaveButton: boolean;
  @Input() showReloadButton: boolean;
  @Input() showCommentButton: boolean;
  @Input() showCancelButton: boolean;
  @Input() showOptButton: boolean;

  @Input() disabledEditButton: boolean;
  @Input() disabledSaveButton: boolean;
  @Input() disabledResetAllButton: boolean;
  @Input() disabledReloadButton: boolean;
  @Input() disabledCommentButton: boolean;
  @Input() disabledCancelButton: boolean;
  @Input() disabledOptButton: boolean;
  @Input() enableResetAll = false;

  @Output() clickResetAll = new EventEmitter<boolean>();
  @Output() clickEditWidget = new EventEmitter<boolean>();
  @Output() clickSaveWidget = new EventEmitter<boolean>();
  @Output() clickResetWidget = new EventEmitter<boolean>(); // è il cancel
  @Output() clickReloadWidget = new EventEmitter<boolean>();
  @Output() clickCreateOpt = new EventEmitter<boolean>();
  @Output() clickCommentWidget = new EventEmitter<boolean>();

  IconWarning = IoniconsOutline.warning;
  IconEdit = IoniconsOutline.edit;
  IconSave = IoniconsOutline.save;
  IconCheck = IoniconsOutline.check;
  IconDoubleCheck = IoniconsOutline.doubleCheck;
  IconReload = IoniconsOutline.reload;
  IconClose = IoniconsOutline.close;
  IconComment = IoniconsFilled.comment;
  IconNoComment = IoniconsOutline.comment;

  IconSize = 18;
}
